import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';

import styles from './Close.less';

const cxb = cx.bind(styles);

Close.propTypes = {
  /** Show as an 'X' or as 'Close'*/
  asLabel: PropTypes.bool,
  /** Callback to call on click */
  onClick: PropTypes.func,
};

/** @private */
function Close({ className, asLabel, onClick }) {
  return (
    <button onClick={onClick} className={cxb('root', { icon: !asLabel }, className)}>
      {asLabel ? (
        <Type.SubText2 as="span" className={cxb('label')}>
          Close
        </Type.SubText2>
      ) : (
        <i className="icon-delete-b" />
      )}
    </button>
  );
}

export default React.memo(Close);

export const Context = React.createContext();
